module.exports = __webpack_public_path__ + "static/media/codepen.cfb68837.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/codepen.png
// module id = 475
// module chunks = 0